@if (statistics) {
	<ul class="segments presence">
		<li data-test="residents-present">
			<label>{{ 'residents.presence.P' | translate }}:</label> {{ statistics.present }}
		</li>
		<li data-test="residents-absent">
			<label>{{ 'residents.presence.A' | translate }}:</label> {{ statistics.absent }}
		</li>
	</ul>
	<ul class="segments gender">
		<li>
			<label>{{ 'labels.gender.males' | translate }}:</label> {{ statistics.male }}
		</li>
		<li>
			<label>{{ 'labels.gender.females' | translate }}:</label> {{ statistics.female }}
		</li>
		@if (statistics.other; as genderOtherCount) {
			<li>
				<label>{{ 'labels.gender.other' | translate }}:</label> {{ genderOtherCount }}
			</li>
		}
	</ul>
}
